// @flow

const documentHelper = {

  // Set document title
  setTitle: (title: string = 'Min Side', prefix: string = 'MinSide - ') => {
    window.document.title = prefix + title;
  },

  // Get document title
  getTitle: () => {
    return window.document.title;
  }
}

export default documentHelper;



// WEBPACK FOOTER //
// ./src/helpers/document.helper.js